import { Grid, Layout } from "antd";
import Footer from "components/layout-components/Footer";
import HeaderNav from "components/layout-components/HeaderNav";
import MobileNav from "components/layout-components/MobileNav";
import PageHeader from "components/layout-components/PageHeader";
import SideNav from "components/layout-components/SideNav";
import TopNav from "components/layout-components/TopNav";
import Loading from "components/shared-components/Loading";
import navigationConfig from "configs/NavigationConfig";
import {
  DIR_LTR,
  DIR_RTL,
  NAV_TYPE_SIDE,
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from "constants/ThemeConstant";
import React, { useEffect, useState } from "react";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { connect } from "react-redux";
import utils from "utils";
import AppViews from "views/app-views";
import gameService from "services/EcosystemService";
import { selectGame } from "redux/actions/Game";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({
  navCollapsed,
  navType,
  location,
  direction,
  selectedGame,
  selectGame,
}) => {
  const currentRouteInfo = utils.getRouteInfo(
    navigationConfig,
    location.pathname
  );
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = !screens.includes("lg");
  const isNavSide = navType === NAV_TYPE_SIDE;
  const isNavTop = navType === NAV_TYPE_TOP;
  const getLayoutGutter = () => {
    if (isNavTop || isMobile) {
      return 0;
    }
    return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH;
  };

  const { status } = useThemeSwitcher();
  const [backendError, setBackendError] = useState(false);
  const [gamesLoaded, setGamesLoaded] = useState(false);

  useEffect(() => {
    gameService.getGames()
      .then((fetchedGames) => {
        if (!selectedGame && fetchedGames?.length > 0) {
          const globalProd = fetchedGames.find((g) => g.id === "global_prod");
          selectGame(globalProd ?? fetchedGames[0]);
        }
        setGamesLoaded(true);
      })
      .catch(() => {
        setBackendError(true);
        setGamesLoaded(true);
      });
  }, []);

  if (backendError) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", gap: "12px" }}>
        <h2>Serviço temporariamente indisponível</h2>
        <p style={{ color: "#888" }}>Não foi possível conectar ao servidor. Tente novamente em alguns instantes.</p>
        <button onClick={() => window.location.reload()} style={{ padding: "8px 24px", cursor: "pointer" }}>
          Tentar novamente
        </button>
      </div>
    );
  }

  if (status === "loading" || (!gamesLoaded && !selectedGame)) {
    return <Loading cover="page" />;
  }

  const getLayoutDirectionGutter = () => {
    if (direction === DIR_LTR) {
      return { paddingLeft: getLayoutGutter() };
    }
    if (direction === DIR_RTL) {
      return { paddingRight: getLayoutGutter() };
    }
    return { paddingLeft: getLayoutGutter() };
  };

  return (
    <Layout>
      <HeaderNav isMobile={isMobile} />
      {isNavTop && !isMobile ? <TopNav routeInfo={currentRouteInfo} /> : null}
      <Layout className="app-container">
        {isNavSide && !isMobile ? (
          <SideNav routeInfo={currentRouteInfo} />
        ) : null}
        <Layout className="app-layout" style={getLayoutDirectionGutter()}>
          <div className={`app-content ${isNavTop ? "layout-top-nav" : ""}`}>
            <PageHeader
              display={currentRouteInfo?.breadcrumb}
              title={currentRouteInfo?.title}
            />
            <Content>
              <AppViews />
            </Content>
          </div>
          <Footer />
        </Layout>
      </Layout>
      {isMobile && selectedGame && <MobileNav />}
    </Layout>
  );
};

const mapStateToProps = ({ theme, game }) => {
  const { navCollapsed, navType, locale } = theme;
  const { selectedGame } = game;
  return { navCollapsed, navType, locale, selectedGame };
};

const mapDispatchToProps = {
  selectGame,
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(AppLayout));
